import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { Validation } from '../../../error/error-messages/validator-messages';
import { Promotion } from '../../../../../models/promotion.model';
import { Router } from '@angular/router';
import { PromotionService } from '../../../../../services/promotion.service';
import { PromotionItemService } from '../../../../../services/promotionItem.service';
import { IPromotionItem } from '../../../../../models/promotionItem.model';
import { Location } from '@angular/common';
@Component({
  selector: 'app-promotion-offer',
  templateUrl: './promotion-offer.component.html',
  styleUrls: ['./promotion-offer.component.scss']
})
export class PromotionOfferComponent implements OnInit {

  // @ts-ignore
  promotions: IPromotion[] = [];
  promotionitems : IPromotionItem[] = [];
  // @ts-ignore
  currentPromotion: IPromotion = [];
  search: any;
  page = 1;
  perPage = 10;
  promotionForm: FormGroup;
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  isTrueName = false;
  @ViewChild('closebutton') closebutton;

  constructor(private fb: FormBuilder, private promotionService: PromotionService ,
              private router :Router, private formB : FormBuilder,
              private promotionItemService: PromotionItemService, private location: Location) { }

  ngOnInit(): void {
    this.loadPromotions();
    this.promotionForm = this.formB.group({
      'name' : ["" , [Validation.nameValidator("Le nom",3,20)]],
      'promotionItem' : ["" , [Validation.requiredValidator("L\'offre")]],
      'description' : ["" , [Validation.nameValidator("La description",2,3)]],
    });
  }

  model = {
    description: ''
  };

  loadPromootionItems(){
    this.promotionItemService.getPromotionItems().subscribe(rs=>{
      this.promotionitems = rs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  onPromotionFormSubmit(){
    const promotion: Promotion = this.promotionForm.value;
    // appel sur service et la méthode d'enregistrement
    this.promotionService.savePromotion(promotion).subscribe(rs => {
      // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La promotion a été ajouté avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.loadPromotions();
      this.reloadComponent();
    }, error => {
      //console.log(error);
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 1500
      });
    });
  }

  isoequalstoname = false;
  verifyPromotionName(){
    return null;
  }


  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  get f1() { return this.editPromotionForm.controls; }

  editPromotionForm = this.fb.group({
    name: new FormControl('', [Validation.nameValidator("Le nom",3,20)]),
    type: new FormControl('', [Validation.nameValidator("Le nom",3,20)]),
    description: new FormControl('', [Validation.nameValidator("Le nom",3,20)]),
    promotionItem: new FormControl('', [Validation.nameValidator("Le nom",3,20)]),
  });

  onEditPromotion(id: any) {
    this.promotionService.getIdPromotion(id).subscribe(rs => {
      this.currentPromotion = rs;
      this.editPromotionForm = this.fb.group({
        name: new FormControl(this.currentPromotion.name, [Validation.nameValidator("Le nom",3,20)]),
        type: new FormControl(this.currentPromotion.type, [Validation.nameValidator("Le nom",3,20)]),
        description: new FormControl('', [Validation.nameValidator("Le nom",3,20)]),
        promotionItem: new FormControl('', [Validation.nameValidator("Le nom",3,20)]),
      });
    });
  }

  loadPromotions = () => {
    this.promotionService.getPromotions().subscribe(data => {
      this.promotions = data;
    }, (err) => {
      // console.log('-----> err', err);
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // console.log(this.perPage);
  }

  searchFilter($event: KeyboardEvent) {
    // console.log(this.search);
    this.promotionService.getPromotions()
      .subscribe(data => {
        this.promotions = data;
        this.promotions = this.promotions.filter(value =>
        value.name.toUpperCase().includes(this.search.toUpperCase())
        || value.type?.includes(this.search.toUpperCase()));
    }, (err) => {
      //console.log('-----> err', err);
    });
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  delete(id: number) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer cette promotion ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.promotionService.deletePromotion(id).subscribe(rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'La promotion a été supprimé avec succés"',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadPromotions();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 2500
            });
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        });
      }
    });
  }


  sort1() {
    if(this.sorted == false) {
      // @ts-ignore
      this.promotions.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted = true;
    } else {
      // @ts-ignore
      this.promotions.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted = false;
    }
  }

  sort2() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.promotions.sort((a, b) => a.promotionItem?.name > b.promotionItem?.name ? 1 : a.promotionItem?.name < b.promotionItem?.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.promotions.sort((a, b) => a.promotionItem?.name < b.promotionItem?.name ? 1 : a.promotionItem?.name > b.promotionItem?.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort3() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.promotions.sort((a, b) => a.description > b.description ? 1 : a.description < b.description ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.promotions.sort((a, b) => a.description < b.description ? 1 : a.description > b.description ? -1 : 0)
      this.sorted2 = false;
    }
  }
}
